<template>
<v-list class='pa-0' :dense='dense' >
  <!--
    TODO:
    1. Add search
    2. Add paging
  -->
  <template v-for='(item, index) in items' >
  <v-list-tile :key='index' @click='$emit("selected", item)' >
    <slot name='avatar-before' :item='item' >
    <v-list-tile-avatar v-if='avatarPosition === "before" && avatarPath' >
      <img :src='getObjectPath(item, avatarPath)' />
    </v-list-tile-avatar>
    </slot>
    <v-list-tile-content>
      <slot name='title' :item='item' >
      <v-list-tile-title >{{getObjectPath(item, titlePath)}}
      </v-list-tile-title>
      </slot>

      <slot name='subtitle' :item='item' >
      <v-list-tile-sub-title v-if='subTitlePath' >
        {{getObjectPath(item, subTitlePath)}}
      </v-list-tile-sub-title>
      </slot>
    </v-list-tile-content>
    <slot name='avatar-after' :item='item' >
    <v-list-tile-avatar v-if='avatarPosition === "after" && avatarPath'>
      <img :src='getObjectPath(item, avatarPath)' />
    </v-list-tile-avatar>
    </slot>
  </v-list-tile>
  <v-divider v-if='withDivider' :key='`div-${index}`' ></v-divider>
  </template>
</v-list>
</template>
<script>
export default {
  name: 'AGDataList',
  props: {
    items: { type: Array, default: () => { return [] } },
    titlePath: { type: String, default: 'title' },
    subTitlePath: { type: String, default: 'subtitle' },
    avatarPath: { type: String, default: null },
    avatarPosition: { type: String, default: 'before' }, // before or after
    actionsPosition: { type: String, default: 'after' }, // before or after
    withDivider: { type: Boolean, default: false },
    dense: { type: Boolean, default: false }
  }
}
</script>



// WEBPACK FOOTER //
// DataList.vue?49c128b4